import { render, staticRenderFns } from "./SuspendedStep.vue?vue&type=template&id=34d35457&scoped=true"
import script from "./SuspendedStep.vue?vue&type=script&lang=ts"
export * from "./SuspendedStep.vue?vue&type=script&lang=ts"
import style0 from "./SuspendedStep.vue?vue&type=style&index=0&id=34d35457&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d35457",
  null
  
)

export default component.exports